import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";

import { Funcionalidade } from "../../models/Funcionalidade.model";
import { Validation } from "./validation";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import { Modulo } from "src/app/models/Modulo.model";
import { FuncionalidadeTipo } from "src/app/models/FuncionalidadeTipo.model";

@Component({
  selector: "app-create-funcionalidade",
  templateUrl: "./formview.component.html",
  styleUrls: ["./form.component.scss"],
})
export class ViewFuncionalidadeComponent implements OnInit {
  public funcionalidadeForm: FormGroup;
  public moduloSelected;
  public funcionalidadeTipoSelected;
  public funcionalidade: Funcionalidade;
  public funcionalidadeId: number;
  public title = "Visualizar Funcionalidade";
  public errorMessage;
  private apiBaseService: ApiBaseService;
  private validation: Validation;
  public types: any = [];
  public modulo: any = [];

  ngOnInit(): void {
    this.funcionalidadeForm = this.formBuilder.group(this.validation.rules());
    this.funcionalidadeId = this.activatedRoute.snapshot.params["id"];
    this.loadFuncionalidade(this.funcionalidadeId);
    this.setup();
  }
  async setup(): Promise<void> {
    const params = {
      size: 100,
      page: 0,
    };

    const modulo = await this.apiBaseService.get<any>({
      url: new Modulo()["nomeConsultaApiBase"],
      params,
    });
    this.modulo = modulo["content"];

    const types = await this.apiBaseService.get<any>({
      url: new FuncionalidadeTipo()["nomeConsultaApiBase"],
      params,
    });
    this.types = types["content"];
  }

  public async loadFuncionalidade(id): Promise<void> {
    try {
      const response = await this.apiBaseService.get<Funcionalidade>({
        url: new Funcionalidade()["nomeConsultaApiBase"] + "/" + id,
      });
      this.funcionalidade = response as Funcionalidade;
      this.fillUserData();
    } catch (error) {
      console.error(error);
    }
  }
  constructor(
    apiBaseService: ApiBaseService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.apiBaseService = apiBaseService;
    this.validation = new Validation();
  }
  fillUserData(): void {
    this.moduloSelected = this.funcionalidade.modulo.id;
    this.funcionalidadeTipoSelected = this.funcionalidade.funcionalidadeTipo.id;

    if (this.moduloSelected) {
      this.funcionalidadeForm.controls["modulo"].setValue(this.moduloSelected);
    }
    if (this.funcionalidadeTipoSelected) {
      this.funcionalidadeForm.controls["funcionalidadeTipo"].setValue(
        this.funcionalidadeTipoSelected
      );
    }

    const fields = [
      "nmFuncionalidade",
      "dsFuncionalidade",
      "cdPath",
      "cdFuncionalidade",
      "sgFuncionalidade",
    ];
    fields.forEach((element) => {
      this.funcionalidadeForm.controls[element].setValue(
        this.funcionalidade[element]
      );
    });
  }
}
